import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, Plus, User, Settings, LogOut, LogIn, Shuffle } from 'lucide-react';

const Navbar = ({ user, isAdmin, onShowAddWord, onShowProfile, onLogin, onLogout, onToggleSearch, onRandom, lang, t }) => {
    const navigate = useNavigate();

    // Common Button Component for responsiveness
    // ... (unchanged helper) ...
    const NavButton = ({ onClick, icon: Icon, label, bgClass, hideLabelOnMobile = true }) => (
        <button
            onClick={onClick}
            className={`
                p-2 md:px-4 md:py-2 
                border-2 border-black 
                shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] 
                active:translate-x-[2px] active:translate-y-[2px] active:shadow-none 
                transition-all 
                flex items-center justify-center gap-2
                ${bgClass}
            `}
            title={label}
        >
            <Icon size={24} strokeWidth={3} />
            <span className={`${hideLabelOnMobile ? 'hidden md:inline' : 'hidden md:inline'} font-black uppercase`}>{label}</span>
        </button>
    );

    return (
        <nav className="fixed w-full top-0 left-0 z-50 bg-[#f0f0f0] border-b-0">
            <div className="w-full max-w-6xl mx-auto px-4 md:px-8 py-4 flex justify-end gap-2 md:gap-4 overflow-x-auto">
                <NavButton
                    onClick={onRandom}
                    icon={Shuffle}
                    label={t?.random || 'Random'}
                    bgClass="bg-[#5CE1E6] hover:bg-[#4bc7cc]"
                />
                <NavButton
                    onClick={onToggleSearch}
                    icon={Search}
                    label={t?.navSearch || 'Search'}
                    bgClass="bg-white hover:bg-gray-100"
                />

                {user ? (
                    <>
                        {isAdmin && (
                            <NavButton
                                onClick={() => navigate('/manage')}
                                icon={Settings}
                                label={t?.manage || 'Manage'}
                                bgClass="bg-[#FFDE59] hover:bg-[#ffe580]"
                            />
                        )}
                        <NavButton
                            onClick={onShowAddWord}
                            icon={Plus}
                            label={isAdmin ? (t?.addWord || 'Add Word') : (t?.suggest || 'Suggest')}
                            bgClass="bg-[#7ED957] hover:bg-[#8ee06a]"
                        />

                        <NavButton
                            onClick={() => onShowProfile()}
                            icon={User}
                            label={t?.profile || 'Profile'}
                            bgClass="bg-[#5CE1E6] hover:bg-[#4bc7cc]"
                        />
                        <NavButton
                            onClick={onLogout}
                            icon={LogOut}
                            label={t?.logout || 'Logout'}
                            bgClass="bg-white hover:bg-gray-100"
                        />
                    </>
                ) : (
                    <NavButton
                        onClick={onLogin}
                        icon={LogIn}
                        label={t?.login || 'Login'}
                        bgClass="bg-[#FF66C4] hover:bg-[#ff85d1]"
                    />
                )}
            </div>
        </nav>
    );
};

export default Navbar;
